<div *ngIf="!iconUrl" class="custom-input">
    <p *ngIf="label">{{label}}<span *ngIf="control?.hasValidator(requiredValidator)" class="required-asterisk">*</span></p>
    <input [ngClass]="{
            'invalid': control.invalid && showError,
            'disabled': control.disabled,
            'input-info-icon': iconUrl
        }"
        [type]="type"
        [formControl]="control"
        maxlength="255"
        [placeholder]="placeholder"
        (keypress)="onKeyPress($event)"
        [ngStyle]="iconUrl ? {'background-image': 'url(' + iconUrl + ')'} : {}"
        [readonly]="readonly">
    <span *ngIf="control.invalid && showError" class="error-message">
        {{getErrorMessage() | translate}}
    </span>
</div>

<div *ngIf="iconUrl" class="icon-input">
    <p *ngIf="label">{{label}}</p>
    <div class="input">
        <input type="text" [placeholder]="placeholder | translate">
        <img [src]="iconUrl" alt="" (click)="iconClicked()">
    </div>
</div>
